import {
    css,
} from '@emotion/react'

const classes = {
    root: css`
        flex-grow: 1;
        width: 100%;
        display: flex;
        min-height: 100%;
        height:100%;
        align-items: center;
        flex-direction: column;
    `,
    header: css`
        width: 100%;
    `,
    content: css`
        display: flex;
        flex-grow: 1;
        flex-direction: column;
        width: 100%;
    `,
    footerCnt: css`
        margin-top: auto;
        width: 100%;
    `,
    footer: css`
        position: relative;
        display: flex;
        flex-direction: column;
        row-gap: 16px;
        column-gap: 16px;
        align-items: center;
        margin: 24px;
    `,
}

export default classes
